import addClasses from '/expert/mobile/addClasses.js';
import removeClasses from '/expert/mobile/removeClasses.js';

export default { addClasses, removeClasses };
